import { useTranslation } from 'react-i18next';
import { Md } from '../components/Md';

export default function TermsPage() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-3xl px-6 py-20 md:py-28">
      <h1 className="font-display text-3xl font-bold tracking-tight md:text-4xl">{t('terms.heading')}</h1>

      <div className="mt-10 space-y-10 text-slate-300 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section1.heading')}</h2>
          <p className="mt-3">{t('terms.section1.p1')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section2.heading')}</h2>
          <ul className="mt-3 list-disc pl-5 space-y-2">
            <li><Md>{t('terms.section2.service')}</Md></li>
            <li><Md>{t('terms.section2.user')}</Md></li>
            <li><Md>{t('terms.section2.company')}</Md></li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section3.heading')}</h2>
          <p className="mt-3">{t('terms.section3.p1')}</p>
          <p className="mt-3">{t('terms.section3.p2')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section4.heading')}</h2>
          <p className="mt-3">{t('terms.section4.p1')}</p>
          <p className="mt-3"><Md>{t('terms.section4.p2')}</Md></p>
          <p className="mt-3">{t('terms.section4.p3')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section5.heading')}</h2>
          <p className="mt-3">{t('terms.section5.p1')}</p>
          <p className="mt-3">{t('terms.section5.p2')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section6.heading')}</h2>
          <p className="mt-3">{t('terms.section6.p1')}</p>
          <ul className="mt-3 list-disc pl-5 space-y-2">
            {(t('terms.section6.items') as unknown as string[]).map((item, i) => (
              <li key={i}><Md>{item}</Md></li>
            ))}
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section7.heading')}</h2>
          <p className="mt-3"><Md>{t('terms.section7.p1')}</Md></p>
          <p className="mt-3">{t('terms.section7.p2')}</p>
          <p className="mt-3">{t('terms.section7.p3')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section8.heading')}</h2>
          <p className="mt-3">{t('terms.section8.p1')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section9.heading')}</h2>
          <p className="mt-3">{t('terms.section9.p1')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section10.heading')}</h2>
          <p className="mt-3">{t('terms.section10.p1')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section11.heading')}</h2>
          <p className="mt-3">{t('terms.section11.p1')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section12.heading')}</h2>
          <p className="mt-3">{t('terms.section12.p1')}</p>
          <p className="mt-3">{t('terms.section12.p2')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section13.heading')}</h2>
          <p className="mt-3">{t('terms.section13.p1')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('terms.section14.heading')}</h2>
          <p className="mt-3"><Md>{t('terms.section14.p1')}</Md></p>
        </section>
      </div>
    </div>
  );
}
